
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contrato/politica-privacidade",
      function () {
        return require("private-next-pages/contrato/politica-privacidade/index.js");
      }
    ]);
  